import request from "@/utils/request";

// 账号密码登录/账号验证码登录
export function loginPhonePassword(data) {
  return request({
    url: '/user/oauth/token',
    method: 'post',
    headers: {
      'Authorization': 'Basic dGM6dGNzZWNyZXQ=',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data,
  })
}
// 微信登录
export function loginByWechat(data) {
  return request({
    url: '/user/oauth/token',
    method: 'post',
    headers: {
      'Authorization': 'Basic dGM6dGNzZWNyZXQ=',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data,
  })
}
// 发送注册验证码
export function loginRegisterCode(params) {
  return request({
    url: '/user/t/customer/auth/register/send-code',
    method: 'post',
    params
  })
}
// 发送登录验证码
export function loginSendCode(params) {
  return request({
    url: '/user/t/customer/auth/login/send-code',
    method: 'post',
    params
  })
}
// 发送修改支付密码验证码
export function payReviseSendCode() {
  return request({
    url: '/user/t/customer/auth/change/pay/password/send-code',
    method: 'post',
  })
}
// 发送修改密码验证码
export function changePasswordSendCode() {
  return request({
    url: '/user/t/customer/auth/change/password/send-code',
    method: 'post',
  })
}
// 获取用户信息
export function getUserInfo(params) {
  const queryString = "?" + Object.entries(params).map(item => item.join("=")).join("&")
  return request({
    url: '/user/introspect' + queryString,
    method: 'get',
  })
}
// 获取分销员等级
export function getUserRank(params) {
  return request({
    url: '/user/retailer/rank',
    method: 'get',
    params
  })
}
// 获取分销员等级规则
export function getUserRankRule(params) {
  return request({
    url: '/setting/distribution/h5/findRetailerRank',
    method: 'get',
    params
  })
}
// 修改登录密码
export function forgetPassword(data) {
  return request({
    url: '/user/customer/change',
    method: 'post',
    data
  })
}
// 修改支付密码
export function forgetPayPassword(data) {
  return request({
    url: '/user/customer/changePayPassword',
    method: 'put',
    data
  })
}

// 注册分销员
export function registerDistributor(params) {
  return request({
    url: '/user/t/customer/auth/inviteCode/register',
    method: 'post',
    data: params
  })
}
// 注册用户
export function registerCustomer(data) {
  return request({
    url: '/user/t/customer/auth/register/bind/superiors',
    method: 'post',
    data
  })
}

// 获取appid（微信）
export function getAppId() {
  return request({
    url: '/user/t/customer/wechat/appid',
    method: 'get'
  })
}
// 绑定微信
export function bindWechat(params) {
  return request({
    url: '/user/t/customer/auth/bind-wx',
    method: 'post',
    params
  })
}

// 输入邀请码
export function confirmInviteCode(params) {
  return request({
    url: '/user/customer/inviteCode',
    method: 'get',
    params
  })
}
// 微信信息
export function getBindWechatInfo(params) {
  return request({
    url: '/user/t/customer/wechat/user-info',
    method: 'get'
  })
}
// 微信签名
export function getWechatSign(params) {
  return request({
    url: '/user/wx/sign',
    method: 'get',
    params
  })
}

// 设置用户昵称
export function setNickname(params) {
  return request({
    url: '/user/customer/change/name',
    method: 'get',
    params
  })
}

// 客户更换上级分销员
export function updateStore(data) {
  return request({
    url: '/user/customer/h5/update-store',
    method: 'post',
    data
  })
}

// 转发跳转
export function shareForward(id) {
  return request({
    url: '/product/activity/forward/' + id,
    method: 'get'
  })
}


//  判断客户微信绑定是否存在，但是无法判断客户是否手机注册
//  return true 用户存在, false 用户不存在
export function wechatExits(openid) {
  return request({
    url: '/t/customer/wechat/exits?openId=' + id,
    method: 'get'
  })
}
